module.exports = __webpack_public_path__ + "img/29.79012b13.png";